const API_BASE_URL = process.env.REACT_APP_API_URL;
console.log("test api url ",API_BASE_URL);

export default API_BASE_URL;